import { ApiState } from "infrastructure/api";
import type { MerchantFeesAndCommisionsRepositoryState } from "./types";

export const stateFactory: () => MerchantFeesAndCommisionsRepositoryState = () => ({
    apiState: ApiState.Idle,
    data: null
});
